import React, { FC, } from "react";
// import { CustomModalProvider } from "../../../Contexts/CustomModalContext";
import CompanyContentTitle from "../CompanyContentTitle";
// import CustomModal from "../../../CustomModalComponent/CustomModal";
// import UpdateAboutModalBody from "../../UpdateAboutModalBody/UpdateAboutModalBody";
import CompanyAboutContent from "../../CompanyAboutContent/CompanyAboutContent";
import "../styles.scss";
// import { useSelector } from "react-redux";
// import { IDefaultState } from "../../../TrixtaComponents/store/reducers";
// import {
//   AboutCompanyContext,
// } from "../../../Contexts/AboutCompanyContext";

interface IProps {
  company: { long_description: string };
}

const AboutSection: FC<IProps> = (props: IProps) => {
  // const { paperstreet } = useSelector((state: IDefaultState) => state);
  const { company } = props;
  // const aboutText: string =
  //   company && company["about"] ? company["about"]["ops"][0]["insert"] : null;

  // const { aboutContent } = useContext(AboutCompanyContext);
  // const {
  //   summary,
  //   businessModel,
  //   marketOpportunity,
  //   summaryTags,
  //   companyTypeTags,
  //   businessModelTags,
  //   marketOpportunityTags,
  // } = aboutContent;

  return (
    <>
      {/* <CustomModalProvider>
        <CompanyContentTitle title="About" />
        <CustomModal>
          <UpdateAboutModalBody />
        </CustomModal>
      </CustomModalProvider> */}

      <CompanyContentTitle title="About" />

      {/* <div className="ps-company-detail-page__about-section-heading">About</div> */}

      <div className="ps-company-content__container">
        <CompanyAboutContent company={company} />
      </div>
      {/* 
      <div className="ps-company-detail-page__lorem-ipsum">
        <CompanyAboutContent
          mainText={businessModel}
          title={"Business Model"}
          tags={businessModelTags.length > 0 ? businessModelTags : ["Demo"]}
          attachments={[]} />
      </div>
      <div className="ps-company-detail-page__lorem-ipsum">
        <CompanyAboutContent
          mainText={marketOpportunity}
          title={"Market Opportunity"}
          tags={marketOpportunityTags.length > 0 ? marketOpportunityTags : ["Demo"]}
          attachments={[]} />
      </div> */}
    </>
  );
};

export default AboutSection;
